export class SaveMultiPdfDialogData {
  selectionName: string;
  description: string;
  isUpdate?: boolean;
}